import { useEffect, useState } from "react";
import { topTicker, hotSearches } from "@/mocks/home";

export default function TopBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % topTicker.length);
    }, 3200);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between gap-3 px-4 md:px-6">
        <div className="flex min-w-0 items-center gap-3">
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-semibold text-background-50">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-background-50" />
            实时更新
          </span>
          <div className="relative hidden h-5 min-w-[220px] overflow-hidden sm:block">
            {topTicker.map((item, i) => (
              <span
                key={item.id}
                className={`absolute inset-0 flex items-center text-xs text-background-300 transition-all duration-500 ${
                  i === index ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
                }`}
              >
                {item.text}
              </span>
            ))}
          </div>
        </div>

        <div className="flex min-w-0 items-center gap-2">
          <span className="hidden text-[11px] text-background-400 lg:inline">热搜</span>
          <div className="flex items-center gap-1.5 overflow-hidden">
            {hotSearches.slice(0, 5).map((word, i) => (
              <button
                key={word}
                type="button"
                className={`${
                  i < 2 ? "inline-flex" : i < 3 ? "hidden md:inline-flex" : "hidden lg:inline-flex"
                } shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] text-background-300 transition-colors hover:bg-background-50/10`}
              >
                <span className="text-accent-400">{i + 1}</span>
                {word}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}